module.exports = "export default __webpack_public_path__ + &quot;cd2a4dc4933d4afa9e296e74e1b291b6.svg&quot;;"